import React, { memo } from "react";
import { Trans, useTranslation } from "react-i18next";
import type { IResult } from "../../interfaces/interfaces";
import { useAppSelector } from "../../store/hooks/hooks";
import Result from "../../components/common/Result";

const EMPTY_RESULTS: IResult[] = [];

const ResultsSection: React.FC = () => {
	const calculator = useAppSelector(state => state.waterContentCalculator);
	const results = calculator?.results ?? EMPTY_RESULTS;
	const { t } = useTranslation();

	return (
		<fieldset className="water-content__result-block round-corner-container">
			<legend>{t('results_title')}</legend>
			{results.map((result) => {
				return (
					<div className="result-row" key={result.id}>
						<Result
							id={result.id}
							label={
								<Trans
									ns="water_content"
									i18nKey={t(`result_labels.${result.id}`)}
									components={{
										sub: <sub />,
										sup: <sup />,
									}}
								/>
							}
							unit={<Trans
								ns="water_content"
								i18nKey={t(`result_units.${result.id}`)}
								components={{
									sub: <sub />,
									sup: <sup />,
								}}
							/>}
							value={result.value?.toString()}
						/>
					</div>
				);
			})}
		</fieldset>
	);
};

export default memo(ResultsSection);
